export default "__VITE_ASSET__CMzT2eJR__";